import './FiltreDossier.css';

/**
 * Bandeau des listes atteintes depuis les boutons d'accès d'une demande
 * (cf. Avancement) : il rappelle sur quel dossier la liste est restreinte et
 * permet d'en sortir.
 *
 * Lever le filtre ne lève pas le repérage : les lignes du dossier restent en
 * vert dans la liste complète (classe `devis-row-cible`), c'est là tout
 * l'intérêt du détour — retrouver le dossier au milieu des autres.
 */
function FiltreDossier({ nom, actif, total, onVoirTout }) {
  if (!actif) return null;

  return (
    <div className="dossier-bandeau">
      <span>
        Liste restreinte au dossier <strong>{nom || 'sélectionné'}</strong>
        {typeof total === 'number' ? ` — ${total} ligne${total > 1 ? 's' : ''}` : ''}.
      </span>
      <button type="button" className="dossier-bandeau-bouton" onClick={onVoirTout}>
        Voir toute la liste
      </button>
    </div>
  );
}

export default FiltreDossier;
